import { cva, VariantProps } from "class-variance-authority"

const BadgeVariants = cva(
  "inline-flex items-center justify-center rounded-sm border px-2 py-0.5 text-xs font-bold w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden",
  {
    variants: {
      variant: {
        green: "bg-primary-green border-primary-green text-primary-text-on-bg",
        secondaryGreen: "bg-secondary-light-green border-secondary-light-green",
        yellow: "bg-secondary-light-yellow border-secondary-light-yellow",
        red: "bg-secondary-coral border-secondary-coral",
        blue: "bg-primary-light-blue border-primary-light-blue",
        accentBlue: "bg-primary-accent-blue border-primary-accent-blue ",
        white: "bg-white border-white",
        lightGrey: "bg-light-grey border-light-grey",
      },
    },
    defaultVariants: {
      variant: "yellow",
    },
  },
)

export type BadgeVariant = VariantProps<typeof BadgeVariants>["variant"]

export default BadgeVariants
